<template>
  <picture><img src="https://mwon.net/gugar-crm/images/logo.png" alt="gugar logo" /></picture>
</template>
